import styled, { css } from 'styled-components';

export type CalloutTone = 'danger' | 'warning' | 'success' | 'info';

/**
 * The tinted box a callout sits in. The accent down its left is a
 * StatusMark, the same rounded bar the order and delivery rows use, rather
 * than a border - hence position relative for it to hang off, and overflow
 * hidden so it does not poke out of the rounded corner. The 16px left padding
 * clears its 6px width. See Callout.tsx, which pairs the two.
 */
export const CalloutSurface = styled.div<{ $tone: CalloutTone }>`
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.darkGray};

  ${({ $tone, theme }) =>
    $tone === 'danger' &&
    css`
      background: ${theme.transparentRed};
    `}

  ${({ $tone, theme }) =>
    $tone === 'warning' &&
    css`
      background: ${theme.yellow}${theme.transparency.t15};
    `}

  ${({ $tone, theme }) =>
    $tone === 'success' &&
    css`
      background: ${theme.transparentGreen};
    `}

  ${({ $tone, theme }) =>
    $tone === 'info' &&
    css`
      background: ${theme.transparentBlue};
    `}
`;
